<template>
    <v-container fluid>   
      <LeftMenu/>     
        <v-layout row wrap>   
          <v-flex xs1></v-flex>
          <v-flex xs10>
            <v-data-table
              :headers="headers"
              :items="bonusTypes"
              :items-per-page="50"
              item-key="id"
              sort-by="exchangeDate"
              :sort-desc=true
              class="elevation-1"
              show-expand
              :search="search"
              :custom-filter="filterOnlyCapsText"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Bonus Types</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="900px">  
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">New Bonus Type</v-btn>
                    </template>                  
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>  
                            <v-flex xs12 sm4 md4>
                              <v-text-field :disabled="editedItem.id > 0" v-model="editedItem.name" label="Name"></v-text-field>
                            </v-flex>                          
                            <v-flex xs12 sm8 md8>
                              <v-text-field v-model="editedItem.explanation" label="Explanation"></v-text-field>
                            </v-flex> 
                            <v-flex xs12 sm4 md4>                              
                              <DatePicker picker-label="Valid From" :date-value="editedItem.validFrom" @dateSelected="editedItem.validFrom=$event" /> 
                            </v-flex>
                            <v-flex xs12 sm4 md4>
                              <DatePicker picker-label="Valid Until" :date-value="editedItem.validUntil" @dateSelected="editedItem.validUntil=$event" /> 
                            </v-flex>      
                            <v-flex xs12 sm4 md4>   
                              <v-combobox
                                :items="currencyListWithText"
                                label="Select Currency"
                                v-model="editedItem.currency"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>                           
                            </v-flex>                                                                                                                                                                                               
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-dialog v-model="coefficientDialog" max-width="900px">                    
                    <v-card>
                      <v-card-title>
                        <span class="headline">Coefficients</span>                        
                      </v-card-title>                      
                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>                            
                            <v-flex xs12 sm6 md6>
                              <v-combobox
                                :items="periodList"
                                label="Start Period"
                                v-model="editedCoefficientItem.startPeriod"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>    
                            </v-flex>                                                          
                            <v-flex xs12 sm6 md6>   
                              <v-combobox
                                :items="periodList"
                                label="End Period"
                                v-model="editedCoefficientItem.endPeriod"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>                         
                            </v-flex>   
                            <v-flex xs12 sm4 md4> 
                              <v-currency-field 
                                :key="editedCoefficientItem.id"
                                v-model="editedCoefficientItem.baseLimitAmount" 
                                label="Base Limit Amount"
                                ></v-currency-field>
                            </v-flex>  
                            <v-flex xs12 sm4 md4>   
                              <v-combobox
                                :items="currencyListWithText"
                                label="Select Currency"
                                v-model="editedCoefficientItem.currency"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>                           
                            </v-flex>  
                            <v-flex xs12 sm6 md4> 
                              <v-text-field v-model="editedCoefficientItem.value" label="Value"></v-text-field>
                            </v-flex>                                                                                                                                                                                           
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="closeCoefficientDialog">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="saveCoefficient">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                </v-toolbar>
                <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
              </template> 
              <template v-slot:expanded-item="{ headers, item: masterItem }">                
                <td :colspan="headers.length" >                  
                  <v-layout row wrap>   
                    <v-flex xs12/>
                    <v-flex xs3>
                      Coefficients                   
                    </v-flex>
                    <v-flex xs9>                       
                    </v-flex>
                    <v-flex xs12>

                      <v-data-table
                      :headers="coefficientHeaders"
                      :items="masterItem.coefficients"
                      :items-per-page="5"
                      item-key="id"
                      sort-by="startPeriod"
                      :sort-desc=true
                      class="elevation-1"
                      >                      
                      <template v-slot:body.append>                    
                      </template>             
                      <template v-slot:item.coefficientAction="{ item }">              
                        <v-icon                  
                          @click="editCoefficientItem(item,masterItem)">
                          mdi-table-edit
                        </v-icon>
                        <v-icon                  
                          @click="deleteCoefficientItem(item,masterItem)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>

                    </v-flex>
                  </v-layout>
                </td>                
              </template>
              <template v-slot:body.append>                    
              </template>             
              <template v-slot:item.action="{ item }">              
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>     
                <v-icon                  
                  @click="addCoefficientItem(item)">
                  mdi-playlist-plus
                </v-icon>             
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs1></v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
import DatePicker from '../../components/DatePicker';
const CURRENCIES_API_URL = 'definitions/currencies';
const API_URL = 'definitions/bonusTypes';
const DETAILS_API_URL = 'definitions/bonusTypeDetails';
const PERIODS_API_URL = 'definitions/periods';
const COEFFICIENTS_API_URL = 'definitions/bonusTypeCoefficients';
export default {
    components:{
      LeftMenu,
      DatePicker
    },
    data () {
    return {
      dialog: false,
      coefficientDialog: false,
      search: '',
      currencyList: [],
      periodList: [],
      bonusTypes: [
        {     
          model: '',
          category: '',
          explanation: '',           
        },               
      ],
      editedCoefficientItem: {},
      editedCoefficientIndex: -1,
      editedIndex: -1,
      editedItem: {
        model: '',
          category: '',
          explanation: '', 
      },
      defaultItem: {
        model: '',
          category: '',
          explanation: '', 
      },
    }
  },
  computed: {
    headers () {
      return [
        { text: 'Name', align: 'left', sortable: true, value: 'name'},
        { text: 'Explanation',  value: 'explanation'  },
        { text: 'Valid From',  value: 'validFrom'  },       
        { text: 'Valid Until',  value: 'validUntil'  },  
        { text: 'Currency',  value: 'currency.code'  },  
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    coefficientHeaders () {
      return [
        { text: 'Start Period',  value: 'startPeriod.text'  },          
        { text: 'End Period', align: 'left', sortable: true, value: 'endPeriod.text'},
        { text: 'Base Limit Amount',  value: 'baseLimitAmount'  },    
        { text: 'Currency',  value: 'currency.code'  },                   
        { text: 'Value',  value: 'value'  },          
        { text: 'Coefficient Actions', value: 'coefficientAction', sortable: false },
      ]
    },
    currencyListWithText(){
      return this.currencyList.map((item) => {
        return {
          id: item.id,
          code: item.code,
          text: item.code+' - '+item.text          
        };
      })
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Bonus Type' : 'Edit Bonus Type'
    },
  },
  created() {    
    this.getCurrencies();
    this.getBonusTypes(); 
    this.getPerformancePeriodList();   
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    coefficientDialog(val){
      val || this.closeCoefficientDialog()
    }
  },
  methods: {
    editItem (item) {
      this.editedIndex = this.bonusTypes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    addCoefficientItem (item) {
      this.editedCoefficientItem.bonusType = Object.assign({}, item);   
      this.coefficientDialog = true
    },
    deleteCoefficientItem (item,masterItem) {
      const index = masterItem.coefficients.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        masterItem.coefficients.splice(index, 1);
        this.deleteCoefficient(item);
      } 
    },
    editCoefficientItem(item, masterItem){  
      this.editedCoefficientIndex = masterItem.coefficients.indexOf(item)
      this.editedCoefficientItem = Object.assign({}, item)      
      this.coefficientDialog = true
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    closeCoefficientDialog () {
      this.coefficientDialog = false
      setTimeout(() => {
        this.editedCoefficientItem = Object.assign({}, this.defaultCoefficientItem)
        this.editedCoefficientIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex > -1) {        
        this.updateBonusType(this.editedItem);
      } else {
        this.addBonusType(this.editedItem);         
      }      
    },
    saveCoefficient(){    
      if(this.editedCoefficientItem.startPeriod && ( this.editedCoefficientItem.baseLimitAmount || this.editedCoefficientItem.baseLimitAmount==0) && 
           this.editedCoefficientItem.currency &&  ( this.editedCoefficientItem.value || this.editedCoefficientItem.value==0)){
        if (this.editedCoefficientIndex > -1) {        
        this.updateCoefficient(this.editedCoefficientItem);
        } else {
          this.addCoefficient(this.editedCoefficientItem);         
        } 
      }else{
        alert('Please fill values');
      }
      
    },
    addCoefficient(coefficientItem){
      this.$axios.post(this.$apiurl + COEFFICIENTS_API_URL, {
        startPeriodId: coefficientItem.startPeriod ? coefficientItem.startPeriod.id : null,
        endPeriodId: coefficientItem.endPeriod ? coefficientItem.endPeriod.id : null,
        bonusTypeId: coefficientItem.bonusType ? coefficientItem.bonusType.id : null,
        currencyId: coefficientItem.currency ? coefficientItem.currency.id : null,
        baseLimitAmount: coefficientItem.baseLimitAmount,
        value: coefficientItem.value
      })
      .then(response => {        
        if (response.status === 201) {
          this.getBonusTypes();
          this.closeCoefficientDialog();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updateCoefficient(coefficientItem){
      let that = this;
      this.$axios.put(this.$apiurl + COEFFICIENTS_API_URL, {
        id : coefficientItem.id,
        startPeriodId: coefficientItem.startPeriod ? coefficientItem.startPeriod.id : null,
        endPeriodId: coefficientItem.endPeriod ? coefficientItem.endPeriod.id : null,
        bonusTypeId: coefficientItem.bonusType ? coefficientItem.bonusType.id : null,
        currencyId: coefficientItem.currency ? coefficientItem.currency.id : null,
        baseLimitAmount: coefficientItem.baseLimitAmount,
        value: coefficientItem.value
      })
      .then(response => {
        if (response.status === 200) {
          this.getBonusTypes();
          this.closeCoefficientDialog();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    addBonusType(item){
      this.$axios.post(this.$apiurl + API_URL, {
        name: item.name,
        explanation: item.explanation,
        validFrom: item.validFrom,
        validUntil: item.validUntil,
        currency: item.currency !=null ? item.currency.id : null
      })
      .then(response => {        
        if (response.status === 201) {
          this.bonusTypes.push(this.editedItem);
          this.close();
        } 
      }).catch(error => {        
          console.log(error);
        }); 
    },
    updateBonusType(item){
      this.$axios.put(this.$apiurl + API_URL, {
        id: item.id,
        name: item.name,
        explanation: item.explanation,
        validFrom: item.validFrom,
        validUntil: item.validUntil,
        ccurrency: item.currency !=null ? item.currency.id : null
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.bonusTypes[this.editedIndex], this.editedItem);
          this.close();
        }         
      }).catch(error => {        
          console.log(error);
        }); 
    },
    deleteBonusType(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },    
    deleteCoefficient(item){
      this.$axios.delete(this.$apiurl + COEFFICIENTS_API_URL+'/'+item.id)
      .then(response => {
        this.getBonusTypes();
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getCurrencies(){     
        this.$axios.get(this.$apiurl + CURRENCIES_API_URL)
            .then(response => {
                this.currencyList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getBonusTypes(){     
      this.$axios.get(this.$apiurl + DETAILS_API_URL)
        .then(response => {
            this.bonusTypes = response.data
        }) 
        .catch(error => {        
          console.log(error);
        });                         
    },
    getPerformancePeriodList(){     
        this.$axios.get(this.$apiurl + PERIODS_API_URL)
            .then(response => {
                this.periodList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
